import React from "react";
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import { Label, Loader, Table } from "semantic-ui-react";
import CustomerButton from "@buttons/CustomerButton";
import { getEventDate } from "@helpers/dates";

const EventDetailsTable = () => {
  const { isLoading, grid, activeRow, onRowClick } = useEventDetailsGrid();

  const headings = [
    {
      name: "ID",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Status",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Date",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Type",
      textAlign: "left",
      collapsing: false,
    },
    {
      name: "Site",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Customer",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Created By",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "Authorised By",
      textAlign: "center",
      collapsing: true,
    },
    {
      name: "QR Period",
      textAlign: "center",
      collapsing: true,
    },
  ];

  const icons = {
    "Age Verification": "birthday cake",
    "Customer Interaction": "talk",
    Incident: "exclamation",
    Observation: "eye",
  };

  if (isLoading) {
    return <Loader active />;
  }

  return (
    <div className="table-overflow flex-stretch-vertical">
      <Table basic="very" celled sortable unstackable compact>
        <Table.Header style={{ position: "sticky" }}>
          <Table.Row>
            {headings.map(({ name, textAlign, collapsing }, index) => {
              return (
                <Table.Cell
                  key={`${name}_${index}`}
                  textAlign={textAlign}
                  collapsing={collapsing}
                  className="font-bold"
                >
                  {name}
                </Table.Cell>
              );
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {grid.map((row) => {
            const {
              id,
              status,
              event,
              site,
              createdByPerson,
              authorisedByPerson,
              yearQuarter,
              customers,
              name,
            } = row;
            return (
              <Table.Row
                key={id}
                onClick={() => {
                  onRowClick(row);
                }}
                className="clickable"
                active={row.id === activeRow?.id}
              >
                <Table.Cell collapsing textAlign="center">
                  <Label>{row.id}</Label>
                </Table.Cell>
                <Table.Cell collapsing textAlign="center">
                  <Label color={status.colour.toLowerCase()}>
                    {status.name}
                  </Label>
                </Table.Cell>
                <Table.Cell singleLine>{getEventDate(row)}</Table.Cell>
                <Table.Cell singleLine textAlign="left">
                  <Label icon={icons[event.name]}>{name}</Label>
                </Table.Cell>
                <Table.Cell singleLine textAlign="center">
                  {site?.name}, {site?.town}
                </Table.Cell>
                <Table.Cell singleLine textAlign="center">
                  {customers.length > 0
                    ? customers.map(({ name }, index) => (
                        <CustomerButton key={index} name={name} />
                      ))
                    : "N/A"}
                </Table.Cell>
                <Table.Cell singleLine textAlign="center">
                  {createdByPerson?.name ?? "N/A"}
                </Table.Cell>
                <Table.Cell singleLine textAlign="center">
                  {authorisedByPerson?.name ?? "N/A"}
                </Table.Cell>
                <Table.Cell singleLine>{yearQuarter}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default EventDetailsTable;
